import Swal from "sweetalert2";
const exc = {
  JWT_EXPIRED: "JWT Expired",
  SESSION_DEAD: "Session Dead",
  SESSION_NOT_FOUND: "Session Not Found",
  SESSION_EXPIRED: "Session Expired",
  USER_NOT_FOUND: "User Not Found",
  JWT_NOT_VALID: "JWT Not Valid",
  IDEAL_SESSION_EXPIRED: "Session Expired",
};
export default class Exceptionservice {
  handlerOtherExcetion = (ex) => {
    if (
      ex === "JWT_EXPIRED" ||
      ex === "SESSION_DEAD" ||
      ex === "JWT_NOT_VALID" ||
      ex === "USER_NOT_FOUND" ||
      ex === "SESSION_NOT_FOUND" ||
      ex === "SESSION_EXPIRED" ||
      ex === "IDEAL_SESSION_EXPIRED"
    ) {
      Swal.fire({
        title: exc[ex],
        text: exc[ex] + " , Click Login To Continue in one step.",
        type: "warning",
        confirmButtonText: "Login",
        allowEscapeKey: false,
        allowOutsideClick: false,
      }).then(() => {
        localStorage.clear();

        if (
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1" ||
          window.location.hostname === ""
        ) {
          window.location = "http://localhost:3000/";
        } else if (window.location.hostname === "giftadmin.mufinpay.com") {
          window.location = "https://giftadmin.mufinpay.com";
        }
        
      });
    }
  };
  handleNetworkException(error) {
    if (!error.response) {
      // Swal.fire({
      //   title: "Network Error",
      //   text: "Check the network cables, modem, and router",
      //   confirmButtonText: "Got It",
      // });
    }
  }
}
